import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Dialog } from "../ui/Dialog"
import { CheckboxItem } from "../ui/Checkbox"
import { Button } from "../ui/Button"
import { popDialog, replaceDialog } from "@/store/dialogs-state"
import { ProjectItem } from "@/store/project/projects-service"
import { projectAtom } from "@/store/project/projects-state"
import { useAtomValue } from "jotai"
import { deleteProject } from "@/store/project/project"
import { LoadingDialog } from "./LoadingDialog"
import { closeSession } from "@/routing/project-session"

export function DeleteProjectDialog(props: { project: ProjectItem }) {
	const { t } = useTranslation("components")
	const [shouldCleanup, setShouldCleanup] = useState<boolean>(false)
	const currentProject = useAtomValue(projectAtom)

	const handleDeleteProject = async () => {
		replaceDialog(LoadingDialog, { title: t("projectDeleteDialog.deletingProject") })

		try {
			await deleteProject(props.project, shouldCleanup)
			if (currentProject) {
				await closeSession({ saveChanges: false, reason: "delete_project" })
			}
		} finally {
			popDialog()
		}
	}
	return (
		<Dialog trackingViewName="delete_project_dialog" contentSize="sm-h-auto" disableClose>
			<div className="flex w-full flex-col items-start justify-start space-y-6">
				<div className="flex flex-col space-y-3">
					<div className="text-start text-md font-bold">
						{t("projectDeleteDialog.deleteProject")}
					</div>
					<div className="flex flex-col space-y-0">
						<div className="text-start text-sm">
							{t("projectDeleteDialog.areYouSureYouWant", {
								var0: props.project.name,
							})}
						</div>
					</div>
					<CheckboxItem
						trackingLabel="cleanup"
						id="cleanup"
						checkedState={shouldCleanup}
						content={
							<div className="flex flex-row items-center space-x-1 text-base-300">
								{t("projectDeleteDialog.deleteWarning")}
							</div>
						}
						onCheckChanged={(_, isChecked) => {
							setShouldCleanup(isChecked)
						}}
					/>
				</div>

				<div className="flex w-full flex-row justify-end space-x-2">
					<Button trackingLabel="cancel" size="sm" onClick={() => popDialog()}>
						{t("common:action.cancel")}
					</Button>
					<Button
						trackingLabel="confirm"
						size="sm"
						variant="destructive"
						onClick={handleDeleteProject}
					>
						{t("projectDeleteDialog.deleteProject")}
					</Button>
				</div>
			</div>
		</Dialog>
	)
}
